import styled from 'styled-components';
import colours from 'theme/atoms/colours';

export const Container = styled.div`
  display: flex;
  gap: 8px;
  padding: 0 5px;
  width: 100%;
  box-sizing: border-box;
  overflow-x: auto;
`;

export const Item = styled.div`
  position: relative;
  flex-shrink: 0;
  width: 72px;
  height: 72px;
  border-radius: 12px;
  overflow: hidden;
  background-color: ${colours.neutral[100]};
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const VideoThumbnail = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: ${colours.neutral[600]};

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const VideoLabel = styled.span`
  font-family: 'Inter Variable', 'Inter', sans-serif;
  font-size: 10px;
  font-weight: 500;
  color: ${colours.neutral[600]};
  text-align: center;
  padding: 0 4px;
`;

export const RemoveButton = styled.button`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: none;
  background-color: rgba(0, 0, 0, 0.6);
  color: ${colours.shade[0]};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  svg {
    width: 12px;
    height: 12px;
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.75);
  }
`;
